<template>
    <div class="vipt">
        <div class="screen" style="width: 197px;display: flex;justify-content: center;align-items: center;">
            <!-- @change="handleChange" -->
            <el-radio-group v-model="receiveStatus" @change="radiochange">
                <el-radio :value="1" :label="1" style="margin-right: 24px;">未领取</el-radio>
                <el-radio :value="2" :label="2">已领取</el-radio>
            </el-radio-group>
        </div>
        <div class="screen">
            <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange2" />
        </div>
        <div class="search">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../assets/secree.png" alt="">

            </div>
            <div>
                <input type="text" placeholder="关键字搜索" v-model="keyword" @keyup.enter="seach">
            </div>
        </div>
        <div class="calendar">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="" end-placeholder="" @change="changedata" format="MM.DD" :clearable="true" />
        </div>
        <!-- <div class="exdown" @click="openDialog">
            <img src="../assets/goodlist/xdown.png" alt="">&nbsp; 下载
        </div> -->
    </div>
    <div class="vipporpe" v-loading="loading">
        <table>
            <thead>

                <tr>
                    <th style="width: 50px;">
                        <!-- <el-checkbox /> -->
                    </th>
                    <th>买家</th>
                    <th style="width: 150px;">礼包</th>
                    <th style="width: 170px;">日期</th>


                    <th style="width: 200px;">收货地址</th>
                    <th style="width: 100px;margin-left: 20px;">发货状态</th>
                    <th style="width: 100px;">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in StoreDatalist" :key="index">
                    <td @click.stop>
                        <!-- <el-checkbox /> -->
                    </td>
                    <td>
                        <div class="stroeh">
                            <!-- <div class="header">
                                <img :src="images(item.productInfo.ppreviewpic)" alt="">
                            </div> -->
                            <div class="header">
                                <img :src="images(item.uuserface)" alt="">
                            </div>
                            <div class="username">
                                <p style="font-size: 16px;color: #111827;">{{ item.urealname || item.uusername }}</p>

                                <p>门铃号：{{ item.uid }}</p>

                            </div>
                            <div class="username">
                                <p>手机号：</p>
                                <p>{{ item.uaTel }}</p>
                            </div>
                        </div>
                    </td>
                    <td>
                        {{ item.name || '暂无数据' }}
                    </td>

                    <td style="line-height: 25px;">

                        {{ datahuan(item.addtime) }}

                    </td>
                    <td>

                        {{ item.address }}

                    </td>

                    <td>
                        <div class="statea">
                            {{ orderState(item.isGift) || '未知' }}

                        </div>
                    </td>
                    <td style="color:#0091FF;cursor: pointer;" @click="fahuo(item.isGift, item)">
                        {{ orderState2(item.isGift, item) || '未知状态' }}
                        <!-- ￥{{ item.orderInfo.omoney.toFixed(2) }} -->
                    </td>
                </tr>

            </tbody>
        </table>
        <div style=" height: 70px;"></div>


    </div>

    <div v-if="keyseache.length >= 1">
        <el-pagination :disabled="loading" class="example-pagination-iskey" background v-model:current-page="current"
            layout="prev, pager, next" :pager-count="5" :page-count="9999999" @current-change="changepige" />
    </div>
    <div class="example-pagination-block" v-else>
        <el-pagination background :disabled="loading" v-model:current-page="current" layout="prev, pager, next"
            :pager-count="5" :total="total" @current-change="changepige" />
    </div>
    <div class="pagechoose">

        显示结果：

        <div class="pagees">

            <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">
        </div>

    </div>
    <Noshu :disabled="loading" :lengths="StoreDatalist.length" ></Noshu>

    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    导出属性
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="exchooses">
                <div class="exchoosee" v-for="(item, index) in exports" :key="index">
                    <div>{{ item.name }}</div>
                    <div>
                        <el-switch v-model="item.chooses" @change="changeex(item.experts, item.chooses)" />
                    </div>
                </div>

            </div>
            <div class="downex">
                <div class="dowm" @click="productExport">
                    下载excel
                </div>
            </div>
        </div>
    </yc-mask>
    <el-dialog v-model="openfahuonow" title="提示" width="500" :before-close="dialogVisible = false">
        <span>接收方式:</span> &nbsp;
        <el-radio-group v-model="receiveType">
            <el-radio :value="1" :label="0" style="margin-right: 24px;">快递</el-radio>
            <el-radio :value="2" :label="1">线下</el-radio>
        </el-radio-group>

        <br>
        <div v-if="receiveType === 0" style="margin-top: 20px;">
            <span>请选择快递公司:</span> &nbsp;
            <el-autocomplete v-model="getDelivery" :fetch-suggestions="querySearch" clearable class="inline-input w-50"
                placeholder="请选择快递公司" @select="handleSelect" /> <br>
            <br>
            <span>请输入快递单号:</span> &nbsp; <el-input v-model="danhao" style="width: 240px" placeholder="请输入快递单号" />
        </div>

        <div v-if="receiveType === 1" style="margin-top: 20px;">
            <span>请填写备注:</span> &nbsp; <el-input v-model="beizhu" style="width: 240px" placeholder="请填写备注" />
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="openfahuonow = false">取消</el-button>
                <el-button type="primary" @click="kuaidfahuo">
                    确定
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import storeapi from '@/api/store'
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus'
import Noshu from '@/components/Noshu.vue'

const store = useStore()
let current = ref(1)
let keyword = ref('')
let startDate = ref('')
let endDate = ref('')
let StoreDatalist = ref([])


let total = ref(100)
let loading = ref(false)
let pageSize = ref(5)

let keywordType = ref(1)

let danhao = ref('')
let getDelivery = ref('')
let getDeliveryCompanyList = ref([])
const openfahuonow = ref(false)
let receiveType = ref(0)
let beizhu = ref('')
let giftOrderId
const fahuo = async (State, item) => {
    if (State == '1') {
        // return '去发货'
        openfahuonow.value = true
        giftOrderId = item.vipId
        const res = await storeapi.getDeliveryCompanyList()
        // getDeliveryCompanyList.value = res.date

        getDeliveryCompanyList.value = Object.entries(res.data).map(([key, value]) => ({ value: value, table: key }));
        console.log('getDeliveryCompanyList', getDeliveryCompanyList.value)

    } else if (State == '2') {
        // return '查看备注'

        ElMessageBox.alert(item.gettypevalue || '暂无备注', '备注', {

            confirmButtonText: '好的',
            callback: (action) => {
                // ElMessage({
                //     type: 'info',
                //     message: `action: ${action}`,
                // })
            },
        })

    }


}
const querySearch = (queryString, cb) => {
    console.log(queryString)
    const results = queryString ? createFilter(queryString) : getDeliveryCompanyList.value
    console.log(results)

    cb(results)
}
const createFilter = (queryString) => {
    // let asc = []
    const asc = getDeliveryCompanyList.value.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
let CompanyCode = null
const handleSelect = (item) => {
    console.log(item)
    getDelivery.value = item.value
    CompanyCode = item.table
}

const kuaidfahuo = async () => {
    let param
    if (receiveType.value == 0) {
        console.log(giftOrderId, getDelivery.value, danhao.value)
        param = {
            giftOrderId,
            deliveryCompanyCode: CompanyCode,
            receiveRemark: danhao.value,
            receiveType: receiveType.value
        }
    } else if (receiveType.value == 1) {
        console.log(giftOrderId, beizhu.value)
        param = {
            giftOrderId,
            receiveRemark: beizhu.value,
            receiveType: receiveType.value

        }
    } else {

    }

    const res = await storeapi.setReceiveRemark(param)

    if (res.success) {
        ElMessage({
            message: '操作成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                giftOrderId = ''
                getDelivery.value = ''
                danhao.value = ''
                beizhu.value = ''
                openfahuonow.value = false
                storelist()
            }
        })
    } else {
        ElMessage.error(res.message)
    }

}

onMounted(() => {
    storelist()
})
const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    storelist()
}

let receiveStatus = ref(null)
const storelist = async () => {
    loading.value = true
    try {
        let data

        if (keyword.value.length > 1) {
            data = {

                "endDate": endDate.value,
                "keyword": keyword.value,
                'keywordType': keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                },
                "startDate": startDate.value
            }
        } else {
            data = {
                "startDate": startDate.value,
                "endDate": endDate.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                }
            }
        }
        let res
        if (receiveStatus.value != null) {
            let param = {
                receiveStatus: receiveStatus.value
            }
            res = await storeapi.pageGiftOrder(data, param)

        } else {
            res = await storeapi.pageGiftOrder(data)

        }


        if (res.success) {
            StoreDatalist.value = res.data.records
            console.log('交易订单', res)
            // emit('totallist', res.data.total)
            total.value = (Math.ceil(res.data.total / pageSize.value))
            console.log('total.value', total.value)
            for (let index = 0; index < StoreDatalist.value.length; index++) {
                StoreDatalist.value[index].chooses = false
            }
            loading.value = false


        }






    } catch (error) {
        // 处理错误
        console.log(error)
    }
}

const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../assets/shop/morentx.png')
    }

}

//跳转页面
const changepige = (val) => {
    console.log(val)
    current.value = val
    storelist()
}
//搜索
let keyseache = ref('')
const seach = () => {
    startDate.value = ''
    endDate.value = ''
    current.value = 1
    receiveStatus.value = null
    keyseache.value = keyword.value

    storelist()
}



const value = ref([])



const orderState = (State) => {

    if (State == '0') {
        return '未领取'
    } else if (State == '1') {
        return '待收货'
    } else if (State == '2') {
        return '已收货'
    }
}
const orderState2 = (State, item) => {
    if (State == '1') {
        return '去发货'
    } else if (State == '2') {
        return '查看备注'
    } else if (State == '0') {
        return '未领取'

    }
}
const options = reactive([

    {
        value: '1',
        label: '用户',
    },
    {
        value: '2',
        label: '礼包名称',
    },
    {
        value: '2',
        label: '收货地址',
    }
])
const radiochange = () => {
    console.log('receiveStatus', receiveStatus.value)
    storelist()
}

const handleChange2 = (value) => {
    console.log(value)
    keywordType.value = value[0]
    // storelist()

}
let nowdata = new Date()
let nextdata = new Date()
const choosedata = ref([nowdata, nextdata])
const changedata = (e) => {
    if (e == null) {
        e = ['', '']
    }
    console.log(e)
    startDate.value = datahuan2(e[0])
    endDate.value = datahuan2(e[1])
    console.log(startDate.value)
    console.log(endDate.value)
    storelist()
}
const datahuan2 = (days) => {
    if (days) {
        const date = new Date(days);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补零
        const day = date.getDate().toString().padStart(2, '0'); // 补零
        return `${year}-${month}-${day}`;
    } else {
        return ''
    }
}
const datahuan = (days) => {
    const date = new Date(days * 1000); // 将时间戳转换为毫秒并创建 Date 对象
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以要加 1，然后补零
    const day = String(date.getDate()).padStart(2, '0'); // 补零
    const hours = String(date.getHours()).padStart(2, '0'); // 补零
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 补零
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 补零
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate
}
//导出
import ycMask from '@/components/mask/mask.vue'
//相关变量
let exports = ref([])
let chooseex = ref([])


//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
//获取遮罩的实例
let maskRef = ref(null);

//筛选表头
const changeex = (experts, chooses) => {
    console.log(experts, chooses)
    if (chooses) {
        chooseex._rawValue.push(experts)
    } else {
        let index = chooseex._rawValue.indexOf(experts);
        chooseex._rawValue.splice(index, 1)
    }
    console.log(chooseex._rawValue)
}



</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;


    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }
}

::v-deep .el-checkbox__input {
    height: 20px;

    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }

    .el-checkbox__inner {
        &::after {
            top: 4px;
            left: 8px;
        }

    }
}

.pagechoose {
    width: 100%;
    height: 70px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0px;
    left: 14px;

    .pagees {
        width: 71px;
        height: 40px;
        border: 1px solid #EEEFF2;
        border-radius: 8px;
        padding: 8px 0 0 0px;
        box-sizing: border-box;

        input {
            width: 80%;


        }
    }
}

.vipt {
    padding-top: 9px;
    margin-left: 15px;
    display: flex;

    .screen {
        width: 168px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 8px;
        margin-right: 24px;
    }

    .search {
        width: 412px;
        height: 48px;
        margin-right: 24px;
        background: #FAFAFA;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #FAFAFA;

        }

        ::placeholder {
            font-weight: 400;
            font-size: 14px;
            color: #7D8592;
        }

    }

    .calendar {
        width: 168px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
    }

    .exdown {
        width: 101px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
        margin-left: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 14px;
        color: #718096;
        cursor: pointer;


        img {
            width: 17px;
            height: 21px;
        }
    }

}

.vipporpe {
    width: 100%;
    // padding-left: 15px;
    box-sizing: border-box;




    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;
            border-bottom: 1px solid #EEEFF2;
            height: 46px;

            th {
                vertical-align: middle;

            }

            th:first-child {
                padding-left: 15px;
            }

            .states {
                text-align: center;
            }
        }

        tbody {
            tr {
                height: 96px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                border-bottom: 1px solid #EEEFF2;

                td:first-child {
                    padding-left: 15px;
                }

                td:nth-child(2) {
                    padding-right: 30px;
                    width: 350px;

                    .stroeh {
                        display: flex;
                        // justify-content: space-b;
                        font-weight: 400;
                        font-size: 14px;
                        color: #718096;

                        .header {
                            width: 48px;
                            height: 48px;
                            margin-right: 14px;
                            border-radius: 24px;
                            overflow: hidden;

                            img {
                                width: 100%;
                                height: 100%;

                            }
                        }

                        .username {

                            margin-right: 14px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;
                        }




                    }
                }

                td:last-child {

                    color: #1787FF;

                }

                td {

                    vertical-align: middle;

                    .statea {
                        width: 66px;
                        height: 42px;
                        background: #EBF3FF;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1787FF;
                        cursor: pointer;
                    }


                }


            }

            tr:hover {
                background-color: #f3f3f3;
            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}
</style>